// api should be here
import router from '@/router';
import { isMobile } from '@/common/ts/common';
import { http } from '@/utils/http';
import { clearAuthToken } from '@/utils/authToken';
import qs from 'qs';
import { clearCqccUserInfo } from '../userInfo';
// 活动api baseurl
const urlPrefix =
  'vote/2026project/q2/2026cq_creative_works/controller.php?enews=';
const TEST_USER_API_ORIGIN = 'https://t8-testapi-proxy.cqcb.com';
const PROD_USER_API_ORIGIN = 'https://t8-api-proxy.cqcb.com';
const LOGIN_PATH = '/api/v1/login/pw';
const MEMBER_INFO_PATH = '/api/v1/member/my/info';
const NEWS_LIST_ONLY_PATH = '/api/v1/newsListOnlyHeadOrTop';
const NEWS_LIST_COLUMN_PATH = '/api/v1/newsListColumn';
const PC_LOGIN_ROUTE = '/cqcc/login';
const CQCC_ROUTE_PREFIX = '/cqcc';

interface PasswordLoginParams {
  phone: string;
  password: string;
}

const getUserApiUrl = (path: string) => {
  if (process.env.NODE_ENV === 'development') {
    return '/wap' + path;
  }

  const origin =
    process.env.VUE_APP_ENV_NAME === 'production'
      ? PROD_USER_API_ORIGIN
      : TEST_USER_API_ORIGIN;
  return `${origin}${path}`;
};

let redirectingToLogin = false;

const isCqccPcRoute = () => {
  const path = router.currentRoute && router.currentRoute.path;

  return (
    !isMobile() &&
    !!path &&
    (path === CQCC_ROUTE_PREFIX || path.indexOf(`${CQCC_ROUTE_PREFIX}/`) === 0)
  );
};

const redirectToLogin = () => {
  if (router.currentRoute.path === PC_LOGIN_ROUTE || redirectingToLogin) {
    return;
  }

  redirectingToLogin = true;
  router
    .replace(PC_LOGIN_ROUTE)
    .catch((err: Error) => err)
    .then(() => {
      redirectingToLogin = false;
    });
};

const handlePcAuthExpired = (response: any) => {
  if (Number(response && response.code) !== 203 || !isCqccPcRoute()) {
    return;
  }

  clearAuthToken();
  clearCqccUserInfo();
  redirectToLogin();
};

const withPcAuthGuard = <T>(request: Promise<T>) => {
  return request.then((response) => {
    handlePcAuthExpired(response);
    return response;
  });
};

const getBaseInfo = () => {
  return withPcAuthGuard(http.get(`${urlPrefix}base-info`));
};

const loginByPassword = (data: PasswordLoginParams) => {
  return withPcAuthGuard(
    http.post(getUserApiUrl(LOGIN_PATH), qs.stringify(data)),
  );
};

const getMemberMyInfo = () => {
  return withPcAuthGuard(http.get(getUserApiUrl(MEMBER_INFO_PATH)));
};
const saveApi = (data: any) => {
  return withPcAuthGuard(http.post(`${urlPrefix}save`, qs.stringify(data)));
};
const updateApi = (data: any) => {
  return withPcAuthGuard(http.post(`${urlPrefix}update`, qs.stringify(data)));
};
const getEducationList = () => {
  return withPcAuthGuard(http.get(`${urlPrefix}education-list`));
};
const getWorkList = (data: any) => {
  return withPcAuthGuard(http.get(`${urlPrefix}user-list`, { params: data }));
};
const getWorkDetail = (data: any) => {
  return withPcAuthGuard(http.get(`${urlPrefix}user-detail`, { params: data }));
};
const getNewsListOnly = (data: any) => {
  return withPcAuthGuard(
    http.get(getUserApiUrl(NEWS_LIST_ONLY_PATH), { params: data }),
  );
};
const getNewsColumn = (data: any) => {
  return withPcAuthGuard(
    http.get(getUserApiUrl(NEWS_LIST_COLUMN_PATH), { params: data }),
  );
};

export {
  getBaseInfo,
  loginByPassword,
  getMemberMyInfo,
  saveApi,
  getEducationList,
  getWorkList,
  getWorkDetail,
  updateApi,
  getNewsListOnly,
  getNewsColumn,
};
